module.exports = __webpack_public_path__ + "static/media/background.4117c1e4.jpg";